import { type } from 'arktype'

export const rcpaxaPricingCategories = ['TECH', 'SOINS', 'SPORT', 'VTC', 'COM', 'AUTRES'] as const
export const rcpaxaPricingCategorySchema = type('===', ...rcpaxaPricingCategories)

/**
 * Ad hoc grouping of rcp axa activities into categories that have the same pricing configuration.
 * Not the same as the family (see @link RcpaxaActivityFamily).
 */
export type RcpaxaPricingCategory = typeof rcpaxaPricingCategorySchema.infer
